import React from 'react';
import Modal, { ModalProps } from '@material-ui/core/Modal';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';

const styles = createStyles({
  scrollable: {
    overflow: 'scroll',
  },
});

interface OwnProps {
  scrollable?: boolean;
}

type Props = OwnProps & ModalProps & WithStyles<typeof styles>;

const ModalNext: React.FC<Props> = ({
  children,
  open,
  onClose,
  classes,
  scrollable = false,
  ...props
}) => (
  <Modal
    open={open}
    onClose={onClose}
    className={scrollable ? classes.scrollable : ''}
    {...props}
  >
    <React.Fragment>{children}</React.Fragment>
  </Modal>
);

export default withStyles(styles)(ModalNext);
